<template>
    <div class="allfooter" style="position: relative; z-index: 20;">
        <div class="f_top">
            <div class="t_logo">
                <img src="@/pc/assets/footer/hn_logo.png" alt="" class="img_hn">
                <img src="@/pc/assets/footer/et_logo.png" alt="" class="img_et">
            </div>
            <div class="t_left">
                <div class="left">
                    <div @click="checkMoreAboutUs">{{$t('h.fl1_1')}}</div>
                    <div @click="clickaboutabracon">{{$t("h.aboutabracon")}}</div>
                    <div @click="clickjoinus">{{$t('h.fl1_2')}}</div>
                </div>
                <div class="left">
                    <div @click="clicklinkcard">{{$t('h.fl2_1')}}</div>
                    <div @click="clickputBrand">{{$t('h.fl2_2')}}</div>
                </div>
                <div class="left">
                    <div @click="clickV">{{$t('h.fl3_1')}}</div>
                    <div @click="clickC">{{$t('h.fl3_2')}}</div>
                    <div @click="clickQ">{{$t('h.fl3_3')}}</div>
                    <div @click="clickW">{{$t('h.fl3_4')}}</div>
                </div>
                <!-- <div class="left">
                    <div @click="clickapplications('1')">{{$t('h.fl4_1')}}</div>
                    <div @click="clickapplications('2')">{{$t('h.fl4_2')}}</div>
                </div> -->
            </div>
            <div class="t_right">
                <div class="right">
                    <img src="@/pc/assets/footer/tel.png" alt="">
                    {{$t('h.fr1_1')}}
                </div>
                <div class="right2" @click="emailClick">
                    <img src="@/pc/assets/footer/email.png" alt="">{{$t('h.fr1_2')}}
                </div>
                <div  class="b1_right">
                    <div class="r_code">
                        <img @mouseenter="mouseenterCode" @mouseleave="mouseleaveCode" src="@/pc/assets/home/l_1.png" alt="">
                        <img v-if="showCode" class="code" src="@/pc/assets/home/code.png" alt="">
                    </div>
                    <a href="http://wpa.qq.com/msgrd?v=3&amp;uin=214526267&amp;site=qq&amp;menu=yes" target="_blank">
                        <img src="@/pc/assets/home/l_2.png" alt="">
                    </a>
                    <a href="https://www.facebook.com/" target="_blank">
                        <img src="@/pc/assets/home/l_3.png" alt="">
                    </a>
                    <a href="https://www.linkedin.com/" target="_blank">
                        <img src="@/pc/assets/home/l_4.png" alt="">
                    </a>
                </div>
            </div>
        </div>
        <div class="f_line"></div>
        <!-- <div class="f_bottom_1">
            <div class="b1_left">
                <img src="@/pc/assets/home/f_logo.png" alt="">
            </div>
            
        </div> -->
        <div class="f_bottom_2">
            <div  class="b2_main">
                <div>
                    <div class="b2_left">
                        <div class="l_address" @click="clickcontactus">
                            <div>{{$t('h.b2l_1')}}</div>
                            <div>{{$t('h.b2l_11')}}</div>
                            <div>{{$t('h.b2l_2')}}</div>
                            <div>{{$t('h.b2l_3')}}</div>
                            <div>{{$t('h.b2l_4')}}</div>
                            <div>{{$t('h.b2l_5')}}</div>
                            <div>{{$t('h.b2l_6')}}</div>
                            <div>{{$t('h.b2l_20')}}</div>
                            <!-- <div>{{$t('h.b2l_7')}}</div> -->
                            <!-- <div>{{$t('h.b2l_8')}}</div> -->
                            <!-- <div>{{$t('h.b2l_9')}}</div> -->
                        </div>
                        <div class="l_link">
                            <a href="https://beian.miit.gov.cn/" target="_self">{{$t('h.b2l_10')}}</a>
                        </div>
                    </div>
                    <div style="margin-top:5px">© 2012-2026 Honeng Electronics. All rights reserved.</div>
                </div>
                <div class="b2_right">
                    <!-- <div>{{$t('h.b2r_1')}}</div> -->
                    <div @click="termsClick">{{$t('h.b2r_2')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data() {
        return{
            showCode:false,
        }
    },
    methods:{
        emailClick() {
            window.open("mailto:sales@honengelec.com", '_blank');
        },  
        mouseenterCode() {
            this.showCode = true
        },
        mouseleaveCode() {
            this.showCode = false
        },
        clickV() {
            localStorage.setItem('activeIndex', 3);
            this.$router.push({name:'vdetails'})
            // window.location.reload();
        },
        clickC() {
            localStorage.setItem('activeIndex', 3);
            this.$router.push({name:'cdetails'})
            // window.location.reload();
        },
        clickQ() {
            localStorage.setItem('activeIndex', 3);
            this.$router.push({name:'qdetails'})
            // window.location.reload();
        },
        clickW() {
            localStorage.setItem('activeIndex', 3);
            this.$router.push({name:'wdetails'})
            // window.location.reload();
        },
        checkMoreAboutUs() {
            localStorage.setItem('activeIndex', 1);
            this.$router.push({name:'aboutus'})
            // window.location.reload();
        },
        clickaboutabracon() {
            localStorage.setItem('activeIndex', 1);
            this.$router.push({name:'aboutabracon'})
            // window.location.reload();
        },
        clicklinkcard() {
            localStorage.setItem('activeIndex', 2);
            this.$router.push({name:'linecard',query: { tip: '1'}})
            // window.location.reload();
        },
        clickputBrand() {
            localStorage.setItem('activeIndex', 2);
            this.$router.push({name:'putBrand',query: { tip: '2'}})
            // window.location.reload();
        },
        clickapplications(val) {
            localStorage.setItem('activeIndex', 4);
            this.$router.push({name:'applications',query: { title: val}})
            // window.location.reload();
        },
        clickjoinus() {
            localStorage.setItem('activeIndex', 1);
            this.$router.push({name:'joinus'})
            // window.location.reload();
        },
        clicklinecard() {
            this.$router.push({name:'linecard'})
        },
        clickcontactus() {
            this.$router.push({name:'contactus'})
        },
        termsClick() {
            this.$router.push({name:'terms'})
        },
        globalClick() {
            this.$router.push({name:'GTCS'})
        },
    }
}
</script>
<style lang="scss">
.allfooter{
    width: 1200px;
    margin: 0 auto;
    .f_top{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 36px;
        padding: 40px 0 30px;
        .t_logo{
            display: flex;
            flex-direction: column;
            .img_hn{
                width: 226px;
                height: 69px;
            }
            .img_et{
                width: 202px;
                height: 45px;
                margin-top: 30px;
            }
        }
        .t_left{
            display: flex;
            align-items: flex-start;
            .left{
                margin-right: 50px;
                div:hover{
                    color: #0E2E61;
                    cursor: pointer;
                }
            }
        }
        .t_right{
            .right{
                display: flex;
                align-items: center;
                img{
                    width: 25px;
                    height: 25px;
                    margin-right: 5px;
                }
            }
            .right2{
                display: flex;
                align-items: center;
                margin: 10px 0 20px 0;
                cursor: pointer;
                img{
                    width: 25px;
                    height: 25px;
                    margin-right: 5px;
                }
            }
            a{
                text-decoration: none;
                color: #333333;
                &:hover{
                    color: #0E2E61;
                }
            }
            .b1_right{
                display: flex;
                align-items: center;
                .r_code{
                    width:45px;
                    height: 45px;
                    position: relative;
                    margin-right: 15px;
                    .code{
                        width: 155px;
                        height: 164px;
                        position: absolute;
                        bottom: 40px;
                        left: -58px;
                    }
                }
                a {
                    width:45px;
                    height: 45px;
                    margin-right: 15px;
                }
                img{
                    width:45px;
                    height: 45px;
                }
            }
        }
    }
    .f_line{
        width: 1200px;
        height: 1px;
        background: #333333;
    }
    .f_bottom_1{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 60px 0 40px;
        .b1_left{
            img{
                width: 287px;
                height: 88px;
            }
        }
    }
    .f_bottom_2{
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        padding:30px 0 20px;
        .b2_main{
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            // margin-bottom: 20px;
            .b2_left{
                display: flex;
                align-items: center;
                .l_address{
                    display: flex;
                    align-items: center;
                    div{
                        color: #0E2E61;
                        border-right: 1px solid #333;
                        padding:0 10px;
                        &:first-child{
                            padding-left: 0;
                        }
                        &:hover{
                            cursor: pointer;
                        }
                    }
                }
                .l_link{
                    margin-left: 10px;
                    a{
                        text-decoration: none;
                        color: #0E2E61;
                    }
                }
            }
            .b2_right{
                // display: flex;
                // align-items: center;
                div{
                    text-align: right;
                    color: #0E2E61;
                    // border-left: 1px solid #333;
                    padding:0 0 0 10px;
                    cursor: pointer;
                    // &:first-child{
                    //     color: #333;
                    //     border-left: none;
                    //     padding-right: 10px;
                    // }
                    &:last-child:hover{
                        cursor: pointer;
                    }
                }
            }
        }
        
    }
}
</style>